module.exports = __webpack_public_path__ + "static/media/YF41_3.fe501e6f.jpg";